export default "__VITE_ASSET__C89Pp9Dr__"